import { createComponent } from "@helpers/admin";
import { Button as ButtonComponent } from "@template/components";
import { useRouter } from "@helpers/hooks/useRouter";
import { DynamicIcon } from "@template/components";

export const Button = createComponent({
  label: "Button",
  component: (props) => {
    const router = useRouter();

    return (
      <ButtonComponent
        onClick={() => {
          if (props.link && props.link.startsWith("/")) {
            router.push(props.link);
          } else if (props.link) {
            window.open(props.link, "_blank");
          }
        }}
        {...props}
      >
        {props.icon && <DynamicIcon name={props.icon} />}
        {props.children}
      </ButtonComponent>
    );
  },
  fields: {
    icon: {
      label: "Icon",
      type: "icon",
    },
    children: {
      label: "Text",
      type: "textarea",
    },
    link: {
      label: "Link",
      type: "textarea",
      default: "",
    },
    title: {
      label: "Title",
      type: "textarea",
    },
    variant: {
      label: "Variant",
      type: "select",
      default: "solid",
      options: [
        {
          label: "Flat",
          value: "flat",
        },
        {
          label: "Solid",
          value: "solid",
        },
        {
          label: "Outline",
          value: "outline",
        },
        {
          label: "Light",
          value: "light",
        },
      ],
    },
    color: {
      label: "Color",
      type: "select",
      default: "primary",
      options: [
        {
          label: "Default",
          value: "default",
        },
        {
          label: "Primary",
          value: "primary",
        },
        {
          label: "Secondary",
          value: "secondary",
        },
        {
          label: "Success",
          value: "success",
        },
      ],
    },
    size: {
      label: "Size",
      type: "select",
      default: "sm",
      options: [
        {
          label: "Extra-Small",
          value: "xs",
        },
        {
          label: "Small",
          value: "sm",
        },
        {
          label: "Medium",
          value: "md",
        },
        {
          label: "Large",
          value: "lg",
        },
      ],
    },
    fullWidth: {
      label: "Full Width",
      type: "boolean",
    },
  },
});
